export default __webpack_public_path__ + "static/media/wdd2021entry.c5936b20.jpg";